var api5Url, api3Url, cw1Url, pcUrl, productDetailUrl, bcDetailUrl, webDetailUrl, href, shopUrl, safeUrl

href = window.location.href
if (href.indexOf('//www.gxzg.org.cn') > -1 || href.indexOf('//gxzg.org.cn') > -1) {
    // 线上英文域名
    api3Url = '//api.gxzg.org.cn'
    cw1Url = 'https://www.qixinyi.cn'
    pcUrl = 'https://www.gxzg.org.cn'
    productDetailUrl = 'http://www.gxzg.org.cn/product'
    bcDetailUrl = 'http://www.gxzg.org.cn/zhigou/detail'
    webDetailUrl = 'http://cw.gxzg.org.cn/web/detail'
    shopUrl = 'https://zhigouyi.cn'
    safeUrl = 'https://api.qixinyi.cn'

} else if (href.indexOf('//xn--vuq70b.xn--fiqs8s') > -1 || href.indexOf('//公信.中国') > -1) {
    // 线上中文域名
    api3Url = '//api.gxzg.org.cn'
    cw1Url = 'https://www.qixinyi.cn'
    pcUrl = 'http://xn--vuq70b.xn--fiqs8s'
    productDetailUrl = 'http://www.gxzg.org.cn/product'
    bcDetailUrl = 'http://www.gxzg.org.cn/zhigou/detail'
    webDetailUrl = 'http://cw.gxzg.org.cn/web/detail'
    shopUrl = 'https://zhigouyi.cn'
    safeUrl = 'https://api.qixinyi.cn'

} else if (href.indexOf('//pc.xn--vuq70b.xn--fiqs8s') > -1 || href.indexOf('//pc.公信.中国') > -1) {
    // 预上线中文域名http://pc.xn--vuq70b.xn--fiqs8s/
    api3Url = '//yyapi.gxzg.org.cn'
    cw1Url = 'https://www.qixinyi.cn'
    pcUrl = 'http://pc.xn--vuq70b.xn--fiqs8s'
    productDetailUrl = 'http://yyclien.gx1.piscn.cn/product'
    bcDetailUrl = 'http://yyclien.gx1.piscn.cn/zhigou/detail'
    webDetailUrl = 'http://yycw.gxzg.org.cn/web/detail'
    shopUrl = 'http://xyzg.xinyongzhigou.com'
    safeUrl = 'https://api.qixinyi.cn'

} else if (href.indexOf('//yyclien.gx1.piscn.cn') > -1) {
    // 预上线英文域名
    api3Url = '//yyapi.gx1.piscn.cn'
    cw1Url = 'https://www.qixinyi.cn'
    pcUrl = 'https://yyclien.gx1.piscn.cn'
    productDetailUrl = 'http://yyclien.gx1.piscn.cn/product'
    bcDetailUrl = 'http://yyclien.gx1.piscn.cn/zhigou/detail'
    webDetailUrl = 'http://yycw.gxzg.org.cn/web/detail'
    shopUrl = 'http://xyzg.xinyongzhigou.com'
    safeUrl = 'https://yyqxyapi2.xygw.org.cn'

} else if (href.indexOf('//yyclien.gx2.piscn.cn') > -1) {
    // 预上线第二套英文域名
    api3Url = '//yyapi.gx2.piscn.cn'
    cw1Url = 'https://www.qixinyi.cn'
    pcUrl = 'https://yyclien.gx2.piscn.cn'
    productDetailUrl = 'http://yyclien.gx2.piscn.cn/product'
    bcDetailUrl = 'http://yyclien.gx2.piscn.cn/zhigou/detail'
    webDetailUrl = 'http://yycw2.gxzg.org.cn/web/detail'
    shopUrl = 'http://xyzg2.xinyongzhigou.com'
    safeUrl = 'https://yyqxyapi2.xygw.org.cn'

} else if (href.indexOf('//www3.gx.tobh.cn') > -1) {
    //  第三套测试机域名
    api3Url = '//api3.gx.tobh.cn'
    cw1Url = 'http://www.qxy.tobh.cn'
    pcUrl = '//www3.gx.tobh.cn'
    productDetailUrl = 'http://www3.gx.tobh.cn/product'
    bcDetailUrl = 'http://www3.gx.tobh.cn/zhigou/detail'
    webDetailUrl = 'http://cw3.gxnw.cn'
    shopUrl = 'http://xyzgtest3.com'
    safeUrl = 'https://www.qixinyi.cn'

} else if (href.indexOf('//www4.gxnw.cn') > -1) {
    //  第四套测试机域名
    api3Url = '//api4.gx.tobh.cn'
    cw1Url = 'http://www.qxy.tobh.cn'
    pcUrl = '//www4.gxnw.cn'
    productDetailUrl = 'http://www4.gxnw.cn/product'
    bcDetailUrl = 'http://www4.gxnw.cn/zhigou/detail'
    webDetailUrl = 'http://cw4.gxnw.cn'
    shopUrl = 'http://xyzgtest4.com'
    safeUrl = 'http://api4.qxy.cn'

} else if (href.indexOf('//www5.gxnw.cn') > -1) {
    //  第五套测试机域名
    api3Url = '//api5.gx.tobh.cn'
    cw1Url = 'http://www.qxy.tobh.cn'
    pcUrl = '//www5.gxnw.cn'
    productDetailUrl = 'http://www5.gxnw.cn/product'
    bcDetailUrl = 'http://www5.gxnw.cn/zhigou/detail'
    webDetailUrl = 'http://cw5.gxnw.cn'
    shopUrl = 'http://xyzgtest5.com'
    safeUrl = 'http://api4.qxy.cn'
} else {
    // 本地开发
    api3Url = '/api3'
    cw1Url = '//cw3.gxnw.cn'
    productDetailUrl = 'http://www3.gx.tobh.cn/product'
    bcDetailUrl = 'http://www3.gx.tobh.cn/zhigou/detail'
    webDetailUrl = 'http://cw1.gxnw.cn'
    pcUrl = 'https://yyclien.gx1.piscn.cn'
    shopUrl = 'http://xyzgtest3.com'
    safeUrl = 'http://api4.qxy.cn'
}
// 环境
export default {
    /**
     * 全局变量
     */
    // objectBaseUrl: 'http://localhost:8080',
    apiCode: '100000', // 全局code
    apiKey: 'aa2144dc6c6e12e0', // 全局Key
    sign: 'aa21a16344dcad046c6e324a12e088fe',
    safeKey: '7663d7de495d3a38',
    safeCode: '110400',

    /**
     * 前端代理HOST
     */
    // api5Url: '/api5',
    // api3Url: '/api3',
    // cw1Url: '/cw1',
    // pcUrl: 'http://www3.gx.tobh.cn',
    /**
     * 测试库HOST
     */
    // api3Url: 'http://api3.gxnw.cn',
    // cw3Url: 'http://cw3.gxnw.cn',
    // pcUrl: 'http://www3.gx.tobh.cn',
    /**
     * 生产环境HOST
     */
    api3Url: api3Url,
    cw1Url: cw1Url,
    pcUrl: pcUrl,
    productDetailUrl: productDetailUrl,
    bcDetailUrl: bcDetailUrl,
    webDetailUrl: webDetailUrl,
    shopUrl: shopUrl,
    safeUrl: safeUrl,
    /**
     * 预上线环境
     * */
    // api3Url: 'https://yyapi.gxzg.org.cn',
    // cw3Url: 'https://yycw.gxzg.org.cn',
    // pcUrl: 'https://yyclien.gx1.piscn.cn',
    // productDetailUrl: 'http://yyclien.gx1.piscn.cn/product',
    // bcDetailUrl: 'http://yyclien.gx1.piscn.cn/zhigou/detail',
    // webDetailUrl: 'http://yycw.gxzg.org.cn/web/detail',
    /**
     * 页面跳转固定URL
     */
    loginUrl: 'https://www.gxzg.org.cn/u/login', // 登录跳转接口
    registerUrl: 'https://www.gxzg.org.cn/u/register', // 注册跳转接口
    uUrl: 'https://www.gxzg.org.cn/u', // 会员中心接口
    logoutUrl: 'https://www.gxzg.org.cn/u/logout', // 退出跳转接口
    claimUrl: 'https://www.gxzg.org.cn/judge', // 认领商品跳转接口
    follow: 'https://www.gxzg.org.cn/u/focus', // 侧边栏关注跳转接口
    // productDetailUrl: 'https://www.gxzg.org.cn/product/', // 商品详情
    feedBackUrl: 'https://www.gxzg.org.cn/feedback', // 侧边栏反馈跳转接口
    contactUSUrl: 'http://wpa.qq.com/msgrd?v=3&uin=3568593033&site=qq&menu=yes' // 侧边栏咨询跳转接口
}



// WEBPACK FOOTER //
// ./src/config/environment.js